import DasherFactoryABI from "@/abi/DasherFactory";
import DasherABI from "@/abi/Dasher";
import { DASHER_FACTORY_ADDRESS, CHAIN_ID } from "@/utils/constants";

/**
 * Smart Contract Configuration
 *
 * This file contains all contract addresses and ABIs for the Befit platform.
 * All contracts are deployed on Base Mainnet (Chain ID: 8453)
 */

// Contract Addresses
export const CONTRACTS = {
  DASHER_FACTORY: {
    address: DASHER_FACTORY_ADDRESS as `0x${string}`,
    abi: DasherFactoryABI,
    chainId: CHAIN_ID,
  },
  // Individual Dasher challenge contracts are created dynamically
  // and their addresses are stored in the database (challenge.id)
} as const;

// Export individual ABIs for convenience
export { DasherFactoryABI, DasherABI };

// Type exports for TypeScript
export type ContractAddress = `0x${string}`;

// Helper function to validate Ethereum addresses
export function isValidAddress(address: string): address is ContractAddress {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
}

// Helper function to get Dasher contract config
export function getDasherContractConfig(challengeAddress: string) {
  if (!isValidAddress(challengeAddress)) {
    throw new Error(`Invalid challenge address: ${challengeAddress}`);
  }

  return {
    address: challengeAddress as ContractAddress,
    abi: DasherABI,
    chainId: CHAIN_ID,
  };
}

// Helper to check if address is a contract (vs EOA)
export async function isContract(
  address: string,
  provider: any
): Promise<boolean> {
  if (!isValidAddress(address)) return false;

  try {
    const code = await provider.getCode(address);
    return code !== "0x" && code !== "0x0";
  } catch {
    return false;
  }
}
